
const hostname = window.location.hostname;

export const base_url = hostname === 'localhost' ? "http://localhost:24000/20200828" 
                      : hostname === 'signup-stage.oraclecloud.com' ? "https://signup-api-stage.oraclecloud.com:8443/20200828"
                      : hostname === 'signup-miglab.oraclecloud.com' ? "https://signup-api-stage.oraclecloud.com/20200828"
                      : hostname === 'signup.oraclecloud.com' ? "https://signup-api.oraclecloud.com/20200828"
                      : hostname === 'signup-pool2.oraclecloud.com' ? "https://signup-api-stage.oraclecloud.com:9443/20200828"
                      : hostname === 'signup-pintlab.oraclecloud.com' ? "https://signup-api-stage.oraclecloud.com:7443/20200828"
                      : hostname === 'signup.cloud.oracle.com' ? "https://signup-api.oraclecloud.com/20200828" : "";
                      
export const env = hostname === 'localhost' ? "dev" 
                : hostname === 'signup-stage.oraclecloud.com' ? "stg"
                : hostname === 'signup-miglab.oraclecloud.com' ? "uat"
                : hostname === 'signup-pool2.oraclecloud.com' ? "uat"
                : hostname === 'signup-pintlab.oraclecloud.com' ? "uat"
                : hostname === 'signup.oraclecloud.com' ? "prd"
                : hostname === 'signup.cloud.oracle.com' ? "prd" : "";

export const signup_environment  = hostname === 'localhost' ? "dev" 
                : hostname === 'signup-stage.oraclecloud.com' ? "stage"
                : hostname === 'signup-miglab.oraclecloud.com' ? "miglab"
                : hostname === 'signup-pool2.oraclecloud.com' ? "pool2"
                : hostname === 'signup-pintlab.oraclecloud.com' ? "pintlab"
                : hostname === 'signup.oraclecloud.com' ? "prd"
                : hostname === 'signup.cloud.oracle.com' ? "prd" : "";

export const courier_service_url = hostname === 'localhost' ? 'https://courier-service-stage.oraclecloud.com/20200828'
                                : hostname === 'signup-stage.oraclecloud.com' ? 'https://courier-service-stage.oraclecloud.com/20200828'
                                : hostname === 'signup-miglab.oraclecloud.com' ? 'https://courier-service-stage.oraclecloud.com/20200828'
                                : hostname === 'signup-pool2.oraclecloud.com' ? 'https://courier-service-stage.oraclecloud.com/20200828'
                                : hostname === 'signup-pintlab.oraclecloud.com' ? 'https://courier-service-stage.oraclecloud.com/20200828'
                                : hostname === 'signup.oraclecloud.com' ? 'https://courier-service.oraclecloud.com/20200828'
                                : hostname === 'signup.cloud.oracle.com' ? 'https://courier-service.oraclecloud.com/20200828' : '';



